import Layout from 'components/ui/Layout';
import BankVerificationModal from 'features/seller/components/BankVerificationModal';
import KycManagementModal from 'features/seller/components/KycManagementModal';
import StatusUpdateModal from 'features/seller/components/StatusUpdateModal';
import { useSeller } from 'features/seller/hooks/useSeller';
import { ArrowLeft, User, XCircle } from 'lucide-react';
import { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
// import EmergencyContactsTab from './EmergencyContactsTab';
import { FinancialTab, KycTab, OverviewTab, StatsTab, EmergencyContactsTab, RefundStatisticsTab } from './components';
import { getStatusColor } from './utils';


const SellerDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, isPending, isError, error } = useSeller(id);

  const seller = data?.data?.seller;

  const staffs = data?.data?.staffs;

  const refundStat= data?.data?.refundStatistics

  // console.log("data for refund", data?.data?.refundStatistics)
  // console.log("data for seller", data?.data?.seller)


  // Check if seller is a staff type (individual service providers)
  const staffTypes = ['home_services_provider', 'beauty_services_provider', 'delivery_partner', 'tourism_guide', 'real_estate_agent'];
  const isStaff = staffTypes.includes(seller?.sellerType);

  // Define valid tabs based on seller type
  const VALID_TABS = isStaff
    // ? ['overview', 'kyc', 'stats']
    ? ['overview', 'kyc', 'emergency contacts']
    // : ['overview', 'kyc', 'financial', 'stats'];
    : ['overview', 'kyc', 'financial', 'emergency contacts', 'refund'];
    // : ['overview', 'kyc', 'stats'];


  const tabFromUrl = searchParams.get('tab');
  const activeTab = VALID_TABS.includes(tabFromUrl) ? tabFromUrl : 'overview';

  const setActiveTab = (tab) => {
    setSearchParams({ tab });
  };

  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [isKycModalOpen, setIsKycModalOpen] = useState(false);
  const [isBankModalOpen, setIsBankModalOpen] = useState(false);

  if (isPending) {
    return (
      <Layout>
        <div className='flex items-center justify-center min-h-screen'>
          <div className='text-center'>
            <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto'></div>
            <p className='mt-4 text-muted-foreground'>Loading seller details...</p>
          </div>
        </div>
      </Layout>
    );
  }

  if (isError) {
    return (
      <Layout>
        <div className='flex items-center justify-center min-h-screen'>
          <div className='text-center'>
            <XCircle className='w-12 h-12 text-destructive mx-auto mb-4' />
            <p className='text-destructive'>Error loading seller: {error?.message || 'Something went wrong'}</p>
            <button
              onClick={() => navigate(-1)}
              className='mt-4 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
            >
              Go Back
            </button>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className='min-h-screen bg-background text-foreground p-6'>
        <div className='max-w-7xl mx-auto'>
          {/* Header */}
          <div className='mb-6'>
            <button
              onClick={() => navigate(-1)}
              className='flex items-center space-x-2 text-muted-foreground hover:text-foreground mb-4 transition-colors'
            >
              <ArrowLeft size={20} />
              <span>Back</span>
            </button>

            <div className='flex items-start justify-between'>
              <div className='flex items-center space-x-4'>
                {seller?.profilePhoto ? (
                  <img
                    src={seller.profilePhoto}
                    alt={`${seller.firstName} ${seller.lastName}`}
                    className='w-20 h-20 rounded-full object-cover border-2 border-border'
                  />
                ) : (
                  <div className='w-20 h-20 rounded-full bg-muted flex items-center justify-center'>
                    <User size={32} className='text-muted-foreground' />
                  </div>
                )}
                <div>
                  <h1 className='text-2xl font-bold text-foreground'>
                    {seller?.firstName} {seller?.lastName}
                  </h1>
                  <p className='text-sm text-muted-foreground'>
                    {/* {seller?.sellerType?.replace('_', ' ').toUpperCase()} */}
                    </p>
                  <div className='flex items-center gap-2 mt-2'>
                    <span
                      className={`px-3 py-1 text-xs font-medium rounded-full capitalize ${getStatusColor(
                        seller?.status
                      )}`}
                    >
                      {seller?.status?.replace('_', ' ')}
                    </span>
                    <span
                      className={`px-3 py-1 text-xs font-medium rounded-full capitalize ${getStatusColor(
                        seller?.kyc?.status
                      )}`}
                    >
                      KYC: {seller?.kyc?.status?.replace('_', ' ')}
                    </span>
                     <span
                      className={`px-3 py-1 text-xs font-medium rounded-full capitalize ${getStatusColor(
                        seller?.bankDetails?.isVerified
                      )}`}
                    >
                      Bank Verification Status:{"  "}
{seller?.bankDetails?.isVerified ? "Verified" : "Not Verified"}
                    </span>
                  </div>
                </div>
              </div>

              <div className='flex gap-2'>
                {/* <button
                  onClick={() => setIsStatusModalOpen(true)}
                  className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
                >
                  Update Status
                </button> */}
                <button
                  onClick={() => setIsStatusModalOpen(true)}
                  disabled={
                    seller?.kyc?.status !== 'approved' 
                    // || seller?.bankDetails?.isVerified !== true
                  }
                  className={`px-4 py-2 text-sm rounded-md transition-colors ${seller?.kyc?.status === 'approved' 
                    // && seller?.bankDetails?.isVerified === true
                      ? 'bg-primary text-primary-foreground hover:bg-primary/90'
                      : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    }`}
                >
                  Update Status
                </button>

                {/* <button
                  onClick={() => setIsKycModalOpen(true)}
                  className='px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-accent transition-colors'
                >
                  Manage KYC
                </button> */}
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className='mb-6'>
            <div className='border-b border-border'>
              <nav className='-mb-px flex space-x-8'>
                {VALID_TABS.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors capitalize ${
                      activeTab === tab
                        ? 'border-primary text-primary'
                        : 'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground'
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Tab Content */}
          <div className='space-y-6'>
            {activeTab === 'overview' && <OverviewTab seller={seller} staffs={staffs} />}
            {activeTab === 'kyc' && <KycTab seller={seller} sellerId={id} />}
            {activeTab === 'emergency contacts' && <EmergencyContactsTab seller={seller} sellerId={id} />}
            {activeTab === 'refund' && <RefundStatisticsTab refundStat={refundStat} sellerId={id} />}
            {activeTab === 'financial' && !isStaff && (
              <FinancialTab seller={seller} onOpenBankModal={() => setIsBankModalOpen(true)} />
            )}
            {activeTab === 'stats' && <StatsTab seller={seller} />}
          </div>
        </div>
      </div>

      {/* Modals */}
      <StatusUpdateModal isOpen={isStatusModalOpen} onClose={() => setIsStatusModalOpen(false)} seller={seller} />
      <KycManagementModal isOpen={isKycModalOpen} onClose={() => setIsKycModalOpen(false)} seller={seller} />
      <BankVerificationModal isOpen={isBankModalOpen} onClose={() => setIsBankModalOpen(false)} seller={seller} />
    </Layout>
  );
};

export default SellerDetails;
